import React from 'react';
import { RouteObject } from 'react-router-dom';
import { SettingsPage } from './views/SettingsPage';

export const routes: RouteObject[] = [
  { path: 'settings', element: <SettingsPage /> },
];

export default routes;